import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import RedirectArrowIcon from 'src/components/Icons/RedirectArrow';

interface StoreCardProps {
  storeName: string;
  storeLabel: string;
  icon: React.ReactNode;
  qrCode: React.ReactNode;
  onClick: () => void;
  isMobile?: boolean;
}

export function StoreCard({ storeName, storeLabel, icon, qrCode, onClick, isMobile }: StoreCardProps) {
  return isMobile ? (
    <Flex
      direction="column"
      bg="#F1F3F5"
      borderRadius="20px"
      p="16px"
      w="100%"
      cursor="pointer"
      onClick={onClick}
      _hover={{ bg: 'gray.100' }}
      transition="background 0.2s"
      position="relative"
    >
      <Box position="absolute" top="16px" right="16px">
        <RedirectArrowIcon width={16} variantColor="primary.1000" />
      </Box>

      <Flex justify="flex-start" mb="12px">
        <Box color="gray.800">{icon}</Box>
      </Flex>

      <Box>
        <Box as="p" fontSize="12px" fontWeight="400" color="#1E252B" mb="2px">
          {storeName}
        </Box>
        <Box as="p" fontSize="16px" fontWeight="600" color="#1E252B">
          {storeLabel}
        </Box>
      </Box>
    </Flex>
  ) : (
    <Flex
      direction="column"
      bg="#F1F3F5"
      borderRadius="20px"
      p="16px"
      w="200px"
      h="200px"
      maxW="200px"
      maxH="200px"
      cursor="pointer"
      onClick={onClick}
      _hover={{ bg: 'gray.100' }}
      transition="background 0.2s"
      flexShrink={0}
    >
      <Flex justify="space-between" align="flex-start">
        <Box color="gray.800">{icon}</Box>
        <Box>
          <RedirectArrowIcon width={16} variantColor="primary.1000" />
        </Box>
      </Flex>

      <Box mt="8px">
        <Box as="p" fontSize="12px" fontWeight="400" color="#1E252B">
          {storeName}
        </Box>
      </Box>
      <Box>
        <Box as="p" fontSize="14px" fontWeight="400" color="#1E252B">
          {storeLabel}
        </Box>
      </Box>

      <Box mt="auto" display="flex" justifyContent="start">
        {qrCode}
      </Box>
    </Flex>
  );
}
